<template>
    <Transition name="mobile-filter">
        <div v-if="show" class="filter-overlay">
            <header class="filter-overlay__header">
                <button
                    type="button"
                    class="btn-close"
                    @click="ridingschoolStore.toggleFilterOverlay">
                    <svgComponent
                        :width="24"
                        :height="24"
                        class-name="icon-filter"
                        icon-name="icon-close"></svgComponent>
                </button>

                <div class="title h5">Filter</div>

                <button type="button" class="btn-clear" @click="clearFilters()">Wis filters</button>
            </header>

            <div class="filter-overlay__body">
                <FilterList v-if="!isDesktop"></FilterList>
            </div>

            <footer class="filter-overlay__footer">
                <button
                    type="button"
                    class="btn-default btn-default--1 btn-w100"
                    @click="ridingschoolStore.toggleFilterOverlay">
                    Toon resulaten
                </button>
            </footer>
        </div>
    </Transition>
</template>

<script setup lang="ts">
import svgComponent from '../../../components/svgComponent.vue';
import FilterList from './filter-list.component.vue';
import { useRidingschoolStore } from '../store/ridingschool.store';

// Composables
import { useMediaQuery } from '../../../composables/useMediaQuery';

defineProps<{
    show: boolean;
}>();

const isDesktop = useMediaQuery('(min-width: 1024px)');

const ridingschoolStore = useRidingschoolStore();

function clearFilters() {
    if (ridingschoolStore.searchUrl !== null) {
        ridingschoolStore.clearSearchParams();
    }
}
</script>
